import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Teacher\MessagesController::index
* @see app/Http/Controllers/Teacher/MessagesController.php:31
* @route '/teacher/messages'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/teacher/messages',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\MessagesController::index
* @see app/Http/Controllers/Teacher/MessagesController.php:31
* @route '/teacher/messages'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\MessagesController::index
* @see app/Http/Controllers/Teacher/MessagesController.php:31
* @route '/teacher/messages'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\MessagesController::index
* @see app/Http/Controllers/Teacher/MessagesController.php:31
* @route '/teacher/messages'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Teacher\MessagesController::show
* @see app/Http/Controllers/Teacher/MessagesController.php:47
* @route '/teacher/messages/{conversation}'
*/
export const show = (args: { conversation: number | { id: number } } | [conversation: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/teacher/messages/{conversation}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\MessagesController::show
* @see app/Http/Controllers/Teacher/MessagesController.php:47
* @route '/teacher/messages/{conversation}'
*/
show.url = (args: { conversation: number | { id: number } } | [conversation: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { conversation: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { conversation: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            conversation: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        conversation: typeof args.conversation === 'object'
        ? args.conversation.id
        : args.conversation,
    }

    return show.definition.url
            .replace('{conversation}', parsedArgs.conversation.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\MessagesController::show
* @see app/Http/Controllers/Teacher/MessagesController.php:47
* @route '/teacher/messages/{conversation}'
*/
show.get = (args: { conversation: number | { id: number } } | [conversation: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\MessagesController::show
* @see app/Http/Controllers/Teacher/MessagesController.php:47
* @route '/teacher/messages/{conversation}'
*/
show.head = (args: { conversation: number | { id: number } } | [conversation: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Teacher\MessagesController::store
* @see app/Http/Controllers/Teacher/MessagesController.php:77
* @route '/teacher/messages/{conversation}'
*/
export const store = (args: { conversation: number | { id: number } } | [conversation: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/teacher/messages/{conversation}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Teacher\MessagesController::store
* @see app/Http/Controllers/Teacher/MessagesController.php:77
* @route '/teacher/messages/{conversation}'
*/
store.url = (args: { conversation: number | { id: number } } | [conversation: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { conversation: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { conversation: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            conversation: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        conversation: typeof args.conversation === 'object'
        ? args.conversation.id
        : args.conversation,
    }

    return store.definition.url
            .replace('{conversation}', parsedArgs.conversation.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\MessagesController::store
* @see app/Http/Controllers/Teacher/MessagesController.php:77
* @route '/teacher/messages/{conversation}'
*/
store.post = (args: { conversation: number | { id: number } } | [conversation: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Teacher\MessagesController::poll
* @see app/Http/Controllers/Teacher/MessagesController.php:103
* @route '/teacher/messages/{conversation}/poll'
*/
export const poll = (args: { conversation: number | { id: number } } | [conversation: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: poll.url(args, options),
    method: 'get',
})

poll.definition = {
    methods: ["get","head"],
    url: '/teacher/messages/{conversation}/poll',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\MessagesController::poll
* @see app/Http/Controllers/Teacher/MessagesController.php:103
* @route '/teacher/messages/{conversation}/poll'
*/
poll.url = (args: { conversation: number | { id: number } } | [conversation: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { conversation: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { conversation: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            conversation: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        conversation: typeof args.conversation === 'object'
        ? args.conversation.id
        : args.conversation,
    }

    return poll.definition.url
            .replace('{conversation}', parsedArgs.conversation.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\MessagesController::poll
* @see app/Http/Controllers/Teacher/MessagesController.php:103
* @route '/teacher/messages/{conversation}/poll'
*/
poll.get = (args: { conversation: number | { id: number } } | [conversation: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: poll.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\MessagesController::poll
* @see app/Http/Controllers/Teacher/MessagesController.php:103
* @route '/teacher/messages/{conversation}/poll'
*/
poll.head = (args: { conversation: number | { id: number } } | [conversation: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: poll.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Teacher\MessagesController::older
* @see app/Http/Controllers/Teacher/MessagesController.php:65
* @route '/teacher/messages/{conversation}/older'
*/
export const older = (args: { conversation: number | { id: number } } | [conversation: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: older.url(args, options),
    method: 'get',
})

older.definition = {
    methods: ["get","head"],
    url: '/teacher/messages/{conversation}/older',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\MessagesController::older
* @see app/Http/Controllers/Teacher/MessagesController.php:65
* @route '/teacher/messages/{conversation}/older'
*/
older.url = (args: { conversation: number | { id: number } } | [conversation: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { conversation: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { conversation: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            conversation: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        conversation: typeof args.conversation === 'object'
        ? args.conversation.id
        : args.conversation,
    }

    return older.definition.url
            .replace('{conversation}', parsedArgs.conversation.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\MessagesController::older
* @see app/Http/Controllers/Teacher/MessagesController.php:65
* @route '/teacher/messages/{conversation}/older'
*/
older.get = (args: { conversation: number | { id: number } } | [conversation: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: older.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\MessagesController::older
* @see app/Http/Controllers/Teacher/MessagesController.php:65
* @route '/teacher/messages/{conversation}/older'
*/
older.head = (args: { conversation: number | { id: number } } | [conversation: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: older.url(args, options),
    method: 'head',
})

const messages = {
    index: Object.assign(index, index),
    show: Object.assign(show, show),
    store: Object.assign(store, store),
    poll: Object.assign(poll, poll),
    older: Object.assign(older, older),
}

export default messages